import { initMetrics, sendEventMetric } from "@expert/cloudwatch-metrics";
import { initLoggingTransmission } from "@expert/logging/src/utils/sendToBackend";
import { env } from "@/config";
import { findPilotGroups } from "../../pilot/pilot";

export declare class CachedUser {
    access_token: string;
    profile: {
        sub: string;
        employeeID: string | null;
        given_name: string | null;
        family_name: string | null;
        userPrincipalName: string | null;
        email: string | null;
        groups: string[];
        partner: string | undefined;
        org?: string;
        salesforceId?: string;
    };
}

export class UserCache {
    private _cachedUser?: CachedUser;

    public setUser(user: CachedUser, userFriendlyName?: string) {
        this._cachedUser = user;
        // TODO: Make it's more elegant. For example by emitting an event
        initLoggingTransmission({ accessToken: user.access_token, collectorUrl: env.logCollectorUrl });
        initMetrics({ accessToken: user.access_token, collectorUrl: env.metricsCollectorUrl });
        void sendEventMetric("sso.authenticated");

        if (!this._cachedUser.profile.employeeID && userFriendlyName) {
            this._cachedUser.profile.employeeID = userFriendlyName;
        }
    }

    public get ssoAccessToken() {
        return this._cachedUser?.access_token;
    }

    public get identity() {
        return this._cachedUser?.profile.sub;
    }

    public get employeeId() {
        return this._cachedUser?.profile.employeeID ?? null;
    }

    public get salesforceId() {
        return this._cachedUser?.profile.salesforceId ?? null;
    }

    public get userPrincipalName() {
        return this._cachedUser?.profile.userPrincipalName ?? null;
    }

    public get userEmail() {
        return this._cachedUser?.profile.email ?? null;
    }

    public get givenName() {
        return this._cachedUser?.profile.given_name ?? null;
    }

    public get familyName() {
        return this._cachedUser?.profile.family_name ?? null;
    }

    public get groups() {
        return this._cachedUser?.profile.groups ?? [];
    }

    public get partner() {
        return this._cachedUser?.profile.partner;
    }

    public containsGroup(group: string) {
        return this._cachedUser?.profile.groups.includes(group);
    }

    public get pilots() {
        return findPilotGroups(this._cachedUser?.profile.groups ?? []);
    }

    public get org() {
        return this._cachedUser?.profile.org;
    }
}

export const userCache = new UserCache();
